// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "dialog-2FoKQ";
var _4 = "header-3jtKM";
var _5 = "wrapper-2Ucjy";
var _6 = "controls-3PmZH";
var _7 = "insurance-biWjM";
var _8 = "insurance__header-1uXkf";
var _9 = "insurance_selected-1oMKz";
var _a = "money-1lg96";
var _b = "rules-1-Rl-";
var _c = "insurance__button-3Dmi9";
var _d = "insurance__button_selected-15Ua3";
var _e = "button__clear-3KfRY";
var _f = "button__done-2xJRe";
var _10 = "mobileHeader-1cT20";
export { _1 as "__esModule", _2 as "mobile", _3 as "dialog", _4 as "header", _5 as "wrapper", _6 as "controls", _7 as "insurance", _8 as "insurance__header", _9 as "insurance_selected", _a as "money", _b as "rules", _c as "insurance__button", _d as "insurance__button_selected", _e as "button__clear", _f as "button__done", _10 as "mobileHeader" }
export default { "__esModule": _1, "mobile": _2, "dialog": _3, "header": _4, "wrapper": _5, "controls": _6, "insurance": _7, "insurance__header": _8, "insurance_selected": _9, "money": _a, "rules": _b, "insurance__button": _c, "insurance__button_selected": _d, "button__clear": _e, "button__done": _f, "mobileHeader": _10 }
